import api from './api';

export const getWhatsAppOptions = () => api.get('/whatsapp/options');
export const getWhatsApps = () => api.get('/whatsapp');
export const getWhatsApp = (id, params) => api.get(`/whatsapp/${id}`, { params });
export const getWhatsAppOfficial = (id) => api.get(`/whatsapp-official/${id}`);
/** @deprecated Super admin: use getSuperAdminWhatsapp from superAdminConnectionsService */
export const getWhatsAppAdmin = (id) => api.get(`/whatsapp-admin/${id}?session=0`);
export const createWhatsApp = (data) => api.post('/whatsapp', data);
export const updateWhatsApp = (id, data) => api.put(`/whatsapp/${id}`, data);
export const updateWhatsAppOfficial = (id, data) => api.put(`/whatsapp-official/${id}`, data);
export const deleteWhatsApp = (id) => api.delete(`/whatsapp/${id}`);
export const deleteWhatsAppOfficial = (id) => api.delete(`/whatsapp-official/${id}`);
export const uploadWhatsAppMedia = (id, formData) =>
  api.post(`/whatsapp/${id}/media-upload`, formData);
export const deleteWhatsAppMedia = (id) => api.delete(`/whatsapp/${id}/media-upload`);
export const uploadWhatsAppOfficialMedia = (id, formData) =>
  api.post(`/whatsapp-official/${id}/media-upload`, formData);
export const deleteWhatsAppOfficialMedia = (id) =>
  api.delete(`/whatsapp-official/${id}/media-upload`);
export const createWhatsAppOfficial = (data) => api.post('/whatsapp-official', data);

export const startWhatsAppSession = (id) => api.post(`/whatsappsession/${id}`);
export const requestNewQrCode = (id) => api.put(`/whatsappsession/${id}`);
export const deleteWhatsAppSession = (id) => api.delete(`/whatsappsession/${id}`);
export const restartWhatsApps = () => api.post('/whatsapp-restart/');

export const closeImportedTickets = (id) => api.post(`/closedimported/${id}`);

export const getPrompts = () => api.get('/prompt');
export const getWhatsAppsWithParams = (params) => api.get('/whatsapp', { params });
export const getAllWhatsApps = (params) => api.get('/whatsapp/all/', { params });
export const deleteAdminWhatsAppSession = (id) => api.delete(`/whatsappsession/admin/${id}`);
export const getPrompt = (id) => api.get(`/prompt/${id}`);
export const createPrompt = (data) => api.post('/prompt', data);
export const updatePrompt = (id, data) => api.put(`/prompt/${id}`, data);
export const deletePrompt = (id) => api.delete(`/prompt/${id}`);
